import { useState } from "react";
import { useParams } from "react-router-dom";
import { useUpdateOrderTable } from "../../../../hooks/api/mutations/useOrder";
import primaryComponents from "../../../primaryComponents";
import { useGetTables } from "../../../../hooks/api/queries";
import TableCard from "./TableCard";
import secondaryComponents from "../../../secondaryComponents";
import styles from "./styles.module.scss";
import Icon from "../../../../assets/icons";
import { pathConstants } from "../../../../routes/pathContants";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import Pagination from "../../Pagination/Pagination";

const UpdateOrderTable = ({
  orderId,
  orderTableId = null,
  storeId,
  closeModal,
}) => {
  const { store_id } = useParams();
  const [queryParams, setQueryParams] = useState({
    store_id: store_id,
  });

  const { handleUpdateOrderTable, isLoading: isUpdatingOrderTable } =
    useUpdateOrderTable({ closeModal });

  const { isLoading: isLoadingOrderTable, data: orderTables } = useGetTables({
    params: "",
    queryParams,
  });

  const updateOrderTable = (tableId) => {
    handleUpdateOrderTable({
      id: orderId,
      data: {
        new_table_id: tableId,
      },
    });
  };

  const handleSearchTables = (value) => {
    const newQueryParams = { ...queryParams };
    if (value?.length === 0) delete newQueryParams.query;
    else newQueryParams.query = value;
    delete newQueryParams.page;
    setQueryParams(newQueryParams);
  };

  const gotoPage = (pageNumber) => {
    const newQueryParams = { ...queryParams };
    newQueryParams.page = pageNumber;
    setQueryParams(newQueryParams);
  };

  return (
    <div className={styles.table_container}>
      <div className={`${globalStyles.tableHeader} justify-content-between`}>
        <primaryComponents.SearchField
          placeholder="Search for a table"
          trigger={(value) => handleSearchTables(value)}
          triggerOnInput={true}
          classNames={globalStyles.searchField}
        />
        <div className="d-flex ml-auto flex-wrap" style={{ gap: "10px" }}>
          <primaryComponents.Button
            type="button"
            classNames={"btn btn--outline"}
            onClick={() => closeModal()}
          >
            <img className="mr-2" src={Icon.closeIcon} alt="" />
            Close
          </primaryComponents.Button>
        </div>
      </div>

      <secondaryComponents.LoaderHelper
        isLoading={isLoadingOrderTable}
        classNames="mt-3"
      >
        {orderTables?.data?.length > 0 ? (
          <div className={styles.card_container}>
            {orderTables?.data
              ?.filter((table) => table.id !== orderTableId)
              ?.map((table, index) => (
                <TableCard
                  key={index}
                  table={table}
                  updateOrderTable={updateOrderTable}
                  isUpdatingOrderTable={isUpdatingOrderTable}
                />
              ))}
          </div>
        ) : (
          <div className={styles.no_table_container}>
            <img className="mr-2" src={Icon.noTableIcon} alt="" />
            <div className={styles.no_table_text}>
              <h4>You have no table</h4>
              <p>Use the button below to add a table.</p>
              <p>When you do, they would appear here.</p>
            </div>
            <primaryComponents.Button
              type="button"
              classNames={"btn btn--primary"}
              onClick={() =>
                window.open(pathConstants.INVENTORY_TABLES, "_blank")
              }
            >
              + Add new table
            </primaryComponents.Button>
          </div>
        )}
      </secondaryComponents.LoaderHelper>

      {orderTables?.length && orderTables?.meta?.next_page > 0 ? (
        <Pagination
          totalPageNumber={orderTables?.meta?.last_page}
          handlePageClick={(value) => gotoPage(value.selected + 1)}
          currentPage={orderTables?.meta?.current_page}
        />
      ) : null}
    </div>
  );
};
export default UpdateOrderTable;
